var oldStartup = __webpack_require__.x;
var hasRun = false;
__webpack_require__.x = function() {
	if (!hasRun) {
	  hasRun = true;
	  __webpack_require__(/*! ./node_modules/.federation/entry.ebfc34f5a62ab98fcb897ed5b2804ec2.js */ "./node_modules/.federation/entry.ebfc34f5a62ab98fcb897ed5b2804ec2.js");
	}
	return oldStartup();
};